// passwordChangeSignal.js — SEC-IDENTITY-01. O servidor recusa com 403
// password_change_required toda chamada de uma conta com troca de senha
// pendente (backend: passwordChangeGate.js). Este aviso faz o AuthContext
// reler /api/auth/me, e o Layout passa a exibir o FirstAccessGate. Nao
// guarda estado: a pendencia continua sendo decidida so pelo servidor.
export const PASSWORD_CHANGE_REQUIRED = 'password_change_required';
export const PASSWORD_CHANGE_REQUIRED_EVENT = 'reacta:password-change-required';

export function notifyPasswordChangeRequired() {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
  try {
    window.dispatchEvent(new Event(PASSWORD_CHANGE_REQUIRED_EVENT));
  } catch { /* sem window em testes */ }
}
